<template>
    <div id="nissan-quiz-longcountdown-ipad" class="nissan-quiz-screen">
        <img class="trivia-logo" src="./../assets/quizz_logo.png" />
        <div class="text-block">
            <p class="large"><i>The game will begin in:</i></p>
            <div id="nissan-longcountdown-text" class="counter">{{timerText}}</div>
            <p>Answer all multiple choice questions correctly to win. Do it in the fastest time, and you could win big!</p>

        </div>
        <div class="disclaimer">
            To claim your prize you must be 18 years of age and present in the Nissan booth during the live game
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Countdown',
  computed: {
    ...mapGetters([
      'remainingTimeInSeconds',
    ]),
    timerText() {
      let remainingSeconds = this.remainingTimeInSeconds;
      if (remainingSeconds < 0) {
        remainingSeconds = 0;
      }
      const minutes = (Math.floor(remainingSeconds / 60));
      let seconds = remainingSeconds - (minutes * 60);
      if (seconds.toString().length === 1) {
        seconds = `0${seconds}`;
      }
      return `${minutes}:${seconds}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
@import './../styles/_global.scss';
@import './../styles/_variables.scss';


.counter {
  font-size: 100px;
  text-align: center;
  margin: 7px 0 0;
}

p {
  margin-left: 10px;
  margin-right: 10px;

  &.large {
    font-size: 30px;
  }
}

@media only screen and (min-width: 600px) {
  .counter {
    font-size: 180px;
  }
  p {
    margin-left: 90px;
    margin-right: 90px;
    &.large {
      font-size: 45px;
    }
  }
}

</style>
